import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SiteLayout from "@/components/layout/SiteLayout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import NakshatraUmbrellasPage from "@/pages/NakshatraUmbrellasPage";
import CorporateBrandingPage from "@/pages/CorporateBrandingPage";
import ManufacturingPage from "@/pages/ManufacturingPage";
import PastClientsPage from "@/pages/PastClientsPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <div className="App" data-testid="keshavalal-company-app">
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/our-umbrellas" element={<Navigate to="/nakshatra-umbrellas" replace />} />
            <Route path="/nakshatra-umbrellas" element={<NakshatraUmbrellasPage />} />
            <Route path="/corporate-branding" element={<CorporateBrandingPage />} />
            <Route path="/manufacturing" element={<ManufacturingPage />} />
            <Route path="/past-clients" element={<PastClientsPage />} />
            <Route path="/gallery" element={<Navigate to="/" replace />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors data-testid="global-toast-notifier" />
      </BrowserRouter>
    </div>
  );
}

export default App;
